<app-header-one></app-header-one>

<!-- <section class="section-b-space">
    <div class="container ">
        <div class="checkout-page">
            <div class="checkout-form">
                <div class="row d-flex">
                    <div class="row d-flex">
                        <div>
                            <a (click)="goTo('/products')" style="cursor: pointer;padding-bottom: 2%;">Back</a>
                        </div>
                        <div class="text-end">
                            <button *ngIf="isLoggedIn" (click)="payNow()" class="btn-solid btn">PAY
                                NOW</button>

                            <button *ngIf="!isLoggedIn" (click)="openLoginDialog()" class="btn-solid btn">LOGIN</button>
                            @joshi

                        </div>
                    </div>

                    <div class="row d-flex">
                        <div class="col-lg-6 col-sm-6 equal-height">

                            <div class="checkout-details">
                                <div class="product-description">
                                    <div class="card">

                                        <div class="card-header">
                                            <h3 class="product-header">{{ rowDetails?.plan_title }}</h3>
                                        </div>
                                        <div class="card-body">
                                            <p class="plan-title"><strong>{{ rowDetails?.plan_title }}</strong></p>
                                            <p class="plan-description">{{ rowDetails?.plan_description }}</p>
                                            <p class="plan-title">{{ rowDetails?.plan_description }}</p>
                                            <p class="plan-title">{{rowDetails?.plan_days}}</p>
                                        </div>
                                        <div class="card-sub-body">
                                            <ul>
                                                <li *ngFor="let plan of rowDetails?.plans">
                                                    {{ plan.description }}
                                                </li>
                                                <li>
                                                    <p>Duration <strong>{{
                                                            rowDetails?.plan_days}}</strong>&nbsp;days&nbsp;
                                                            +&nbsp;
                                                         Extra <strong> {{
                                                            rowDetails?.grace_days}}</strong>&nbsp;days 
                                                        </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-sm-6 equal-height">
                            <div class="checkout-details">
                                <span *ngIf="paymentFailedStatus" style="color: #BF0000;"
                                    [innerHTML]="paymentFailedMsg"></span>
                                <div class="order-box">
                                    <div class="title-box">
                                        <div>Product Total</div>
                                    </div>
                                    <ul class="qty">
                                        <li>Plan Price <span>{{ rowDetails?.plan_price | currency:'INR' }}</span>
                                        </li>
                                        <li>
                                            <span *ngIf="rowDetails.discount_type==='NA'">Discount</span>
                                            <span *ngIf="rowDetails.discount_type==='P'">Discount <sub
                                                    *ngIf="rowDetails?.offer_discount_percentage > 0"
                                                    style="color: #BF0000;">({{rowDetails.offer_discount_percentage}}%)</sub></span>
                                            <span *ngIf="rowDetails.discount_type==='F'">Discount Flat <sub
                                                    *ngIf="rowDetails?.offer_discount_flat > 0"
                                                    style="color: #BF0000;">({{rowDetails.offer_discount_flat |
                                                    currency:'INR'}})</sub></span>

                                            <span
                                                *ngIf="rowDetails.discount_type === 'P' || rowDetails.discount_type === 'NA'">{{
                                                rowDetails.discount_price}}</span>
                                            <span *ngIf="rowDetails.discount_type==='F'">{{
                                                rowDetails.discount_price |
                                                currency:'INR' }}</span>
                                        </li>
                                        <li>Sub Total <span>{{ rowDetails.sub_total | currency:'INR' }}</span></li>
                                        <li>GST <span>{{ rowDetails.gst_total | number:'1.2-2'}}%</span></li>
                                    </ul>
                                    <ul class="total">
                                        <li>Total Payable <span>{{ rowDetails?.total_payble |
                                                currency:'INR':'symbol':'1.2-2'}}</span></li>
                                    </ul>

                                    <div class="row">
                                        <div class="col-lg-12">&nbsp;</div>
                                    </div>


                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="row d-flex"  *ngIf="isLoggedIn && this.rowDetails.module_name === 'JOBS' || this.rowDetails.module_name === 'JOBS_DB'" >
                        <div class="col-lg-6 col-sm-6 equal-height">
                            <div class="checkout-details">
                                <div class="product-description">
                                    <p *ngIf="!isLoggedIn">Login to see your company details</p>


                                    <div class="card"
                                        *ngIf="isLoggedIn && this.rowDetails.module_name === 'JOBS' || this.rowDetails.module_name === 'JOBS_DB'">

                                        <div class="card-header">
                                            <h3 class="product-header">Invoice Details</h3>
                                        </div>
                                        <div class="card-body">
                                            <span >Company</span>
                                            <p class="plan-title">{{ companyObject.company_name }}</p>
                                        </div>
                                        <div class="card-sub-body">
                                            <ul>
                                                <li>
                                                    {{ companyObject.contact_name }}</li>
                                                <li> {{ companyObject.contact_number }}</li>
                                                <li> {{ companyObject.contact_email }}</li>
                                                <li> {{ companyObject.cin }}</li>
                                                <li> {{ companyObject.pan }}</li>
                                                <li> {{ companyObject.gst }}</li>
                                            </ul>
                                            <address>
                                                {{ companyObject.street_1 }}
                                                {{ companyObject.street_2 }}<br>
                                                {{ companyObject?.city_details?.city_name }},
                                                {{ companyObject?.state_details?.state_name }} -
                                                {{ companyObject.pincode }}
                                            </address>

                                        <ul>
                            <li *ngFor="let plan of rowDetails?.plans">
                                {{ plan.description }}
                            </li>
                            <li>
                              <p>Duration <strong>{{ rowDetails?.plan_days}}</strong>&nbsp;days&nbsp;+&nbsp;
                              Extra <strong> {{ rowDetails?.grace_days}}</strong>&nbsp;days</p>                                            </li>
                        </ul> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->


<app-breadcrumb [title]="'Products'" [breadcrumb]="'products'"></app-breadcrumb>
<section class="section-b-space">
    <div class="container">
        <div class="checkout-page">
            <div class="checkout-form">
                <!-- <form> -->
                <div class="row">
                    <div class="col-lg-6 col-sm-12 col-xs-12">


                        <div class="checkout-title"
                            *ngIf="isLoggedIn && this.rowDetails.module_name === 'JOBS' || this.rowDetails.module_name === 'JOBS_DB'">
                            <h3>Company Details</h3>
                        </div>
                        <div class="row check-out"
                            *ngIf="isLoggedIn && this.rowDetails.module_name === 'JOBS' || this.rowDetails.module_name === 'JOBS_DB'">
                            <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                <div class="field-label">Company Name:</div>
                                <span>{{ companyObject.company_name }}</span>

                                <!-- <input type="text" name="firstname" [formControl]="checkoutForm.controls['firstname']" value="" placeholder="" autocomplete="off"> -->
                                <!-- <div *ngIf="checkoutForm.controls.firstname.touched && checkoutForm.controls.firstname.errors?.required" class="text text-danger">
                                    First Name is required.
                                    </div>
                                    <div *ngIf="checkoutForm.controls.firstname.touched && checkoutForm.controls.firstname.errors?.pattern" class="text text-danger">
                                    First Name must be an alphabates.
                                    </div> -->
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                <div class="field-label">Contact Name:</div>
                                <span> {{ companyObject.contact_name }}</span>

                                <!-- <input type="text" name="lastname" [formControl]="checkoutForm.controls['lastname']" value="" placeholder="" autocomplete="off">
                                    <div *ngIf="checkoutForm.controls.lastname.touched && checkoutForm.controls.lastname.errors?.required" class="text text-danger">
                                    Last Name is required.
                                    </div>
                                    <div *ngIf="checkoutForm.controls.lastname.touched && checkoutForm.controls.lastname.errors?.pattern" class="text text-danger">
                                    Last Name must be an alphabates.
                                    </div> -->
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                <div class="field-label">Phone:</div>
                                <span> {{ companyObject.contact_number }}</span>
                                <!-- <input type="text" name="phone" [formControl]="checkoutForm.controls['phone']" value="" placeholder="" autocomplete="off">
                                    <div *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.required" class="text text-danger">
                                     Phone No is required.
                                    </div>
                                    <div *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.pattern" class="text text-danger">
                                      Phone No is must be number.
                                    </div> -->
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                <div class="field-label">Email Address:</div>
                                <span>{{ companyObject.contact_email }}</span>
                                <!-- <input type="text" name="email" [formControl]="checkoutForm.controls['email']" value="" placeholder="" autocomplete="off">
                                    <div *ngIf="checkoutForm.controls.email.touched && checkoutForm.controls.email.errors?.required" class="text text-danger">
                                     Email is required
                                    </div>
                                    <div *ngIf="checkoutForm.controls.email.touched && checkoutForm.controls.email.errors?.email" class="text text-danger">
                                     Invalid Email
                                    </div> -->
                            </div>

                            <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                <div class="field-label">Address:</div>
                                <address>
                                    {{ companyObject.street_1 }}
                                    {{ companyObject.street_2 }}<br>
                                    {{ companyObject?.city_details?.city_name }},
                                    {{ companyObject?.state_details?.state_name }} -
                                    {{ companyObject.pincode }}
                                </address>

                                <!-- <input type="text" name="address" [formControl]="checkoutForm.controls['address']" value="" placeholder="" autocomplete="off">
                                    <div *ngIf="checkoutForm.controls.address.touched && checkoutForm.controls.address.errors?.required" class="text text-danger">
                                     Address is required
                                    </div>
                                    <div *ngIf="checkoutForm.controls.address.touched && checkoutForm.controls.address.errors?.maxlength" class="text text-danger">
                                      Maximum 50 character
                                    </div> -->
                            </div>

                            <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                <div class="field-label">CIN:</div>
                                <span> {{ companyObject.cin }}</span>

                                <!-- <select name="country" [formControl]="checkoutForm.controls['country']">
                                        <option value="" selected>Select Country</option>
                                        <option value="India">India</option>
                                        <option value="USA">USA</option>
                                        <option value="Australia">Australia</option>
                                    </select>
                                    <div *ngIf="checkoutForm.controls.country.touched && checkoutForm.controls.country.errors?.required" class="text text-danger">
                                     Country is required
                                    </div> -->
                            </div>

                            <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                <div class="field-label">PAN:</div>
                                <span> {{ companyObject.pan }}</span>

                                <!-- <input type="text" name="town" [formControl]="checkoutForm.controls['town']" value="" placeholder="" autocomplete="off">
                                     <div *ngIf="checkoutForm.controls.town.touched && checkoutForm.controls.town.errors?.required" class="text text-danger">
                                     City is required
                                    </div> -->
                            </div>
                            <div class="form-group col-md-12 col-sm-6 col-xs-12">
                                <div class="field-label">GST:</div>
                                <span> {{ companyObject.gst }}</span>

                                <!-- <input type="text" name="state" [formControl]="checkoutForm.controls['state']" value="" placeholder="" autocomplete="off">
                                     <div *ngIf="checkoutForm.controls.state.touched && checkoutForm.controls.state.errors?.required" class="text text-danger">
                                     State is required
                                    </div> -->
                            </div>
                            <!-- <div class="form-group col-md-12 col-sm-6 col-xs-12">
                                    <div class="field-label">Postal Code</div>
                                    <input type="text" name="postalcode" [formControl]="checkoutForm.controls['postalcode']" value="" placeholder="" autocomplete="off">
                                    <div *ngIf="checkoutForm.controls.postalcode.touched && checkoutForm.controls.postalcode.errors?.required" class="text text-danger">
                                     Postalcode is required
                                    </div>
                                </div> -->
                        </div>
                        <div class="row ">
                            <div class="col-12">
                                <div class="stripe-section">
                                    <h5>{{ rowDetails?.plan_title }}</h5>
                                    <div class="content">
                                        <h5>{{ rowDetails?.plan_description }}</h5>
                                        <h5>{{rowDetails?.plan_days}}</h5>
                                        <h5 *ngFor="let plan of rowDetails?.plans">{{ plan.description }}</h5>

                                        <!-- <table>
                                            <tr>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td ></td>
                                            </tr>
                                             <tr>
                                      <td>cvc</td>
                                      <td>2222</td>
                                    </tr> 
                                        </table> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row margin-cls">
                            <div class="col-12">
                              <div class="stripe-section">
                                <h5>paypal</h5>
                                <div class="content">
                                  <h5>dummy test</h5>
                                  <table>
                                    <tr>
                                      <td>cart number</td>
                                      <td>4152521541244</td>
                                    </tr>
                                    <tr>
                                      <td>mm/yy</td>
                                      <td>11/18</td>
                                    </tr>
                                    <tr>
                                      <td>cvc</td>
                                      <td>521</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div> -->
                    </div>


                    <div class="col-lg-6 col-sm-12 col-xs-12">
                        <div class="checkout-details">
                            <div class="order-box">
                                <div class="title-box">
                                    <div>Product <span> Total</span></div>
                                </div>
                            
                                <ul class="qty">
                                    <li>
                                        {{ rowDetails?.plan_title }}
                                        <span>
                                            {{ rowDetails?.plan_price | currency:'INR' }}
                                        </span>
                                    </li>
                                    <li>
                                        {{getDiscountLabel(rowDetails)}}
                                        <span
                                            *ngIf="rowDetails.discount_type === 'P' || rowDetails.discount_type === 'NA'">{{rowDetails.discount_price}}</span>

                                        <span *ngIf="rowDetails.discount_type==='F'">{{rowDetails.discount_price |
                                            currency:'INR' }}</span>

                                    </li>
                                    <li>
                                        GST({{ rowDetails?.gst_total }})%
                                        <span>
                                            
                                        </span>
                                    </li>
                                </ul>

                                <ul class="sub-total">
                                    <li>
                                        Subtotal <span class="count">{{ rowDetails.sub_total | currency:'INR' }}</span>
                                    </li>
                                    <!-- <li *ngIf='products.length'>
                                        Shipping
                                        <div class="shipping">
                                            <div class="shopping-option">
                                                <input type="radio" name="shipping" checked="checked"
                                                    id="free-shipping">
                                                <label for="free-shipping">Shipping</label>
                                            </div>
                                            <div class="shopping-option">
                                                <input type="radio" name="shipping" id="local-pickup">
                                                <label for="local-pickup">Local Pickup</label>
                                            </div>
                                        </div>
                                    </li> -->
                                </ul>
                                <ul class="total">
                                    <li>Total <span class="count">{{ rowDetails?.total_payble |
                                            currency:'INR':'symbol':'1.2-2'}}</span></li>
                                </ul>
                            </div>

                            <div class="payment-box">
                                <!-- <div class="upper-box">
                                    <div class="payment-options">
                                        <ul>
                                            <li>
                                                <div class="radio-option">
                                                    <input type="radio" [(ngModel)]="payment" [value]="'Stripe'"
                                                        name="payment-group" id="payment-2">
                                                    <label for="payment-2">Stripe
                                                        <span class="small-text">Please send a check to Store Name,
                                                            Store
                                                            Street, Store Town, Store State / County, Store
                                                            Postcode.</span></label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="radio-option paypal">
                                                    <input type="radio" [(ngModel)]="payment" [value]="'Paypal'"
                                                        name="payment-group" id="payment-3">
                                                    <label for="payment-3">PayPal<span class="image"><img
                                                                src="assets/images/paypal.png" alt="" /></span></label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div> -->
                                <div class="text-end">
                                    <button *ngIf="isLoggedIn" (click)="payNow()" class="btn-solid btn">PAY
                                        NOW</button>

                                    <button *ngIf="!isLoggedIn" (click)="openLoginDialog()" class="btn-solid btn">LOGIN
                                        TO PAY</button>
                                    <!-- <ngx-paypal [config]="payPalConfig" *ngIf="payment == 'Paypal'"></ngx-paypal> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- </form> -->
        </div>
    </div>
</section>


<app-footer-one></app-footer-one>


<ng-template #confirmationDialog>
    <h2 mat-dialog-title>Confirmation</h2>
    <mat-dialog-content>Please fill your company details to purchase your desired plans.</mat-dialog-content>
    <mat-dialog-actions style="flex-direction: row;
    display: flex;
    justify-content: space-around;padding: 5% 0;">
        <button class="btn-solid btn" [mat-dialog-close]="false">Cancel</button>
        <button class="btn-solid btn" [mat-dialog-close]="true">Ok</button>
    </mat-dialog-actions>
</ng-template>